module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/uk.86d64249.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/uk.png
// module id = 2793
// module chunks = 11